import { render, staticRenderFns } from "./AuditLogs.vue?vue&type=template&id=47ad4017&scoped=true&"
import script from "./AuditLogs.vue?vue&type=script&lang=ts&"
export * from "./AuditLogs.vue?vue&type=script&lang=ts&"
import style0 from "./AuditLogs.vue?vue&type=style&index=0&id=47ad4017&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ad4017",
  null
  
)

export default component.exports